/**
 * Component: Site navigation
 * ------------------------------------------------------------------------------
 * The meganav dropdown for vehicles.
 *
 * @namespace siteNav
 */

import log from 'salvo-lite/log'

class SiteNav {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem

        this._settings = {
            ...JSON.parse(elem.getAttribute('data-sitenav') || '{}')
        }

        this._selectors = {
            siteNavItem: '[data-sitenav-item]',
            megamenu: '.site-megamenu'
        }

        this._nodeSelectors = {
            siteNavItem: this._elem.querySelectorAll(this._selectors.siteNavItem),
            megamenu: this._elem.querySelectorAll(this._selectors.megamenu)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
   * Initialise component.
   */
    onInit () {
        this._setListeners()
        this._setDefault()
    }

    _setListeners () {
        this._nodeSelectors.siteNavItem.forEach((siteNavItem) => {
            const megamenu = siteNavItem.querySelector('.site-megamenu')
            siteNavItem.addEventListener('mouseenter', () => {
                this._nodeSelectors.megamenu.forEach((element) => element.classList.remove('active'))

                if (megamenu !== null) {
                    this._setDefault(true)

                    document.body.classList.add('site-nav--open')
                    megamenu.classList.add('active')
                    const menuItems = this._elem.querySelectorAll('.site-megamenu__item')

                    menuItems.forEach(item => {
                        const children = item.querySelectorAll('.menulist__parent')
                        const wrapper = item.querySelector('.site-megamenu__wrapper')
                        let timeout = null

                        if (children !== null) {
                            if (wrapper !== null) {
                                item.addEventListener('mouseenter', () => {
                                    timeout = setTimeout(() => {
                                        wrapper.classList.add('active')
                                        item.classList.add('active')
                                    }, 500)
                                })

                                item.addEventListener('mouseleave', () => {
                                    clearTimeout(timeout)
                                    wrapper.classList.remove('active')
                                    item.classList.remove('active')
                                })
                            }

                            children.forEach(child => {
                                child.addEventListener('mouseenter', (e) => {
                                    this._toggleSubMenu(children, child, 'mouseenter')
                                })

                                child.addEventListener('mouseleave', (e) => {
                                    this._toggleSubMenu(children, child, 'mouseleave')
                                })
                            })
                        }
                    })
                }

                this._elem.addEventListener('mouseleave', () => {
                    if (megamenu !== null) {
                        document.body.classList.remove('site-nav--open')
                        megamenu.classList.remove('active')
                    }

                    this._setDefault()
                })
            })

            this._elem.addEventListener('mouseleave', () => {
                if (megamenu !== null) {
                    const menuItems = megamenu.querySelectorAll('.site-megamenu__item')
                    menuItems.forEach(item => {
                        const children = item.querySelectorAll('.menulist__parent')
                        children.forEach(child => {
                            child.parentElement.classList.remove('active')
                        })
                    })
                }

                this._setDefault()
            })
        })
    }

    _toggleSubMenu (children, child) {
        children.forEach((item) => {
            item.parentElement.classList.remove('active')
        })

        child.parentElement.classList.add('active')
    }

    _setDefault (hide = false) {
        let defaultMenu = null

        this._nodeSelectors.siteNavItem.forEach((element) => {
            if (this._settings.template === 'accessories-hub' && element.getAttribute('data-sitenav-item') === 'accessories') defaultMenu = element
            if (this._settings.template === 'accessories-hub' && element.getAttribute('data-sitenav-item') === 'accessori') defaultMenu = element
            if (this._settings.template === 'parts-hub' && element.getAttribute('data-sitenav-item') === 'parts') defaultMenu = element
            if (this._settings.template === 'performance-parts' && element.getAttribute('data-sitenav-item') === 'performance') defaultMenu = element
        })

        if (defaultMenu === null) return

        const defaultMegaMenu = defaultMenu.querySelector('.site-megamenu')

        if (hide === true) {
            defaultMenu.classList.remove('active')
            defaultMegaMenu.classList.remove('active')
        } else {
            defaultMenu.classList.add('active')
            defaultMegaMenu.classList.add('active')
        }
    }
}

export default SiteNav



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SiteNav.js